import moment from "moment";
import accounting from "accounting";

export function getTheDate(timestamp, format) {
  let time = timestamp * 1000;
  let formatDate = format ? format : "MM-DD-YYYY";
  return moment(time).format(formatDate);
}

export const HUMAN_DATE_FORMAT = "DD/MM/YYYY";

export const HUMAN_DATE_WITH_TIME_FORMAT = "DD/MM/YYYY h:mma";

export function dateToHuman(date) {
  return moment(date).format(HUMAN_DATE_FORMAT);
}

export function dateToHumanWithTime(date) {
  return moment(date).format(HUMAN_DATE_WITH_TIME_FORMAT);
}

export function unixToHuman(date) {
  return moment.unix(date).format(HUMAN_DATE_FORMAT);
}

export function convertDateToTimeStamp(date, format) {
  let formatDate = format ? format : "YYYY-MM-DD";
  return moment(date, formatDate).unix();
}

export function textTruncate(str, length, ending) {
  if (length == null) {
    length = 100;
  }
  if (ending == null) {
    ending = "...";
  }
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  } else {
    return str;
  }
}

export function hexToRgbA(hex, alpha) {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
      "," +
      alpha +
      ")"
    );
  }
  throw new Error("Bad Hex");
}

/**
 * Firestore rejects undefined (including nested). Drop those keys.
 * @param {unknown} value
 * @returns {unknown}
 */
export function omitUndefinedDeep(value) {
  if (Array.isArray(value)) {
    return value.map(omitUndefinedDeep);
  }
  if (!value || typeof value !== "object") {
    return value;
  }
  if (Object.prototype.toString.call(value) !== "[object Object]") {
    return value;
  }
  const out = {};
  Object.keys(value).forEach(key => {
    if (value[key] === undefined) return;
    out[key] = omitUndefinedDeep(value[key]);
  });
  return out;
}

export function formatMoney(value) {
  return accounting.formatMoney(value, "€", 2, ",", ".");
}

export function generateUUID() {
  // Public Domain/MIT
  var d = new Date().getTime(); //Timestamp
  var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
